<template>
  <div class="base-block">
    <div class="block-title">
      <icon-svg class="title-icon" icon-class="block-title-icon"></icon-svg>
      <div class="title-text">{{title}}</div>
      <div
        v-if="unfold"
        class="unfold-icon"
        @click="unfoldChange"
      >
        <icon-svg :icon-class="open ? 'block-retract' : 'block-open'"></icon-svg>
      </div>
    </div>
    <div class="block-content" v-show="open">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseBlock',

  props: {
    title: String,
    unfold: {
      type: Boolean,
      default: false
    },
    unfoldControl: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    unfoldControl (val) {
      this.open = val
    }
  },

  data () {
    return {
      open: true
    }
  },

  methods: {
    unfoldChange () {
      const status = !this.open
      this.open = status
      this.$emit('unfoldFeedback', status)
    }
  }
}
</script>

<style lang="less" scoped>
.base-block {
  .wrapper;
  margin-top: 10px;
  .block-title {
    display: flex;
    align-items: center;
    height: 28px;
    padding: 0 12px;
    font-size: 14px;
    color: #333;
    background-color: #f6f7f9;
    .title-text {
      flex: 1;
    }
    .title-icon,
    .unfold-icon {
      margin-right: 12px;
      font-size: 14px;
    }
    .unfold-icon {
      cursor: pointer;
    }
  }
}
</style>
